const APPLE_PAY_SDK_URL = 'https://applepay.cdn-apple.com/jsapi/1.latest/apple-pay-sdk.js'

/**
 * Apple exposes `ApplePaySession` only on supported devices, and touching it over
 * plain HTTP throws, so every access goes through this guard.
 */
export const canUseApplePay = (): boolean => {
	try {
		const session = (window as any).ApplePaySession
		return Boolean(session?.canMakePayments?.())
	} catch {
		return false
	}
}

let applePaySdkPromise: Promise<void> | null = null

/** Loads Apple's SDK once so the <apple-pay-button> custom element is defined. */
export const loadApplePaySdk = (): Promise<void> => {
	if (applePaySdkPromise) return applePaySdkPromise

	applePaySdkPromise = new Promise<void>((resolve, reject) => {
		const existing = document.querySelector<HTMLScriptElement>(
			`script[src="${APPLE_PAY_SDK_URL}"]`,
		)

		if (existing) {
			if (existing.dataset.loaded === 'true') return resolve()
			existing.addEventListener('load', () => resolve())
			existing.addEventListener('error', () => reject(new Error('Apple Pay SDK failed to load')))
			return
		}

		const script = document.createElement('script')
		script.src = APPLE_PAY_SDK_URL
		script.async = true
		script.crossOrigin = 'anonymous'
		script.addEventListener('load', () => {
			script.dataset.loaded = 'true'
			resolve()
		})
		script.addEventListener('error', () => reject(new Error('Apple Pay SDK failed to load')))
		document.head.appendChild(script)
	})

	return applePaySdkPromise
}
